import React, { useState, useEffect } from "react";
import "./Patients.css";

import { Row, Col } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar/Sidebar";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import SelectField from "../../Components/Commons/Forms/SelectField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import ProfilePictureUpload from "../ProfilePictureUpload/ProfilePictureUpload";
import DateField from "../Commons/Forms/DateField";
import TypeAhead from "../../Components/Commons/Forms/TypeAhead";
import ConfirmModal from "../../Components/Modals/ConfirmModal";

import { createAllergy } from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi";
import { getPatients } from "../../Components/Helpers/API/PatientApi/PatientApi";
import {
  validatePatientProfile,
  validatePatientSearch,
} from "../Helpers/Utilities/Validations/PatientValidations";
import { createPatient, createPatientCSR } from "../Helpers/API/PatientApi/PatientApi";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AddPatientForm from "../Forms/AddPatientForm/AddPatientForm";
import { searchCustomer } from "../Helpers/API/QrDiagnosticsApi/QrDiagnosticsApi";
import AntDTable from "../AntDTable/AntDTable";
import { getAge, getMonths } from "../Helpers/Utilities/Common";
import {
  buildPhilhealthAutofillLocks,
  isPhilhealthFieldLocked,
} from "../Helpers/Utilities/philhealthAutofillLock";
// import { all } from "axios";

function AddPatient() {
  const navigate = useNavigate();
  const location = useLocation();
  const { type } = useParams();
  const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [sex, setSex] = useState("");
  const [fileList, setFileList] = useState([]);
  const [userData, setUserData] = useState([]);
  const [prompt, setPrompt] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(false);
  const [addPatient, setAddPatient] = useState({
    last_name: "",
    first_name: "",
    middle_name: "",
    suffix: "",
    birthdate: "",
    contact_no: "",
    email: "",
    sex: null,
    emergency_contact: "",
    emergency_contact_no: "",
    relation_w_contact: "",
    senior_id: "",
    is_pwd: "0",
    pwd_id: "",
    country: "PHILIPPINES",
    province: "",
    city: "",
    barangay: "",
    street: "",
    zip_code: "",
    civil_status: null,
    occupation: "",
    nationality: "FILIPINO",
    religion: "",
    ph_check: true,
    phic_membership_type: "member",
    phic_last_name: "",
    phic_first_name: "",
    phic_middle_name: "",
    phic_extension_name: "",
    phic_birthdate: "",
    phic_contact_no: "",
    phic_pin: "",
    phic_dependent_pin: "",
    phic_enlistment_date: "",
    phic_enlistment_status: "active",
    phic_package_type: "Konsulta Package",
    phic_atc: "WALKEDIN",
    file_url: "",
    liveness_check_screenshot: null,
    remarks: "",
  });
  const [isError, setError] = useState({
    last_name: false,
    first_name: false,
    address: false,
    birthdate: false,
    sex: false,
  });
  const [allergyData, setAllergyData] = useState({
    allergyDetails: [
      {
        type: "",
        name: "",
      },
    ],
  });
  const [isChecked, setIsChecked] = useState(false);
  const [philhealthAutofillLocks, setPhilhealthAutofillLocks] = useState(
    () => new Set()
  );

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  function handleAddPatient() {
    handleSubmit();
  }

  // Function get patient data API
  async function fetchPatientData() {
    const response = await getPatients();
    if (response.data) {
      const names = response?.data?.data?.map((data) => ({
        label: data.full_name,
        value: data.id,
        last_name: data.last_name,
        first_name: data.first_name,
      }));
      setUserData(names);
    } else {
      setUserData([]);
    }
  }

  useEffect(() => {
    fetchPatientData();
  }, []);
  useEffect(() => {
    const state = location.state || {};
    const lsPhicPin = localStorage.getItem("phic_pin") || "";
    const lsPhicDependentPin = localStorage.getItem("phic_dependent_pin") || "";
    const lsMembership = localStorage.getItem("phic_membership_type") || "";
    
    if (state?.fromPhilhealthRegistration && state?.autofillData) {
      setPhilhealthAutofillLocks(
        buildPhilhealthAutofillLocks(state.autofillData, {
          ...state,
          fromPhilhealthRegistration: true,
        })
      );
    } else {
      setPhilhealthAutofillLocks(new Set());
    }

    // Handle autofill data from PhilHealth or clinic registration
    if (state?.autofillData) {
      const autofill = state.autofillData;
      setAddPatient((prev) => ({
        ...prev,
        // Basic patient information
        last_name:
          autofill.last_name ||
          autofill.phic_last_name ||
          prev.last_name,
        first_name:
          autofill.first_name ||
          autofill.phic_first_name ||
          prev.first_name,
        middle_name:
          autofill.middle_name ||
          autofill.phic_middle_name ||
          prev.middle_name,
        suffix:
          autofill.suffix ||
          autofill.phic_extension_name ||
          prev.suffix,
        birthdate:
          autofill.birthdate ||
          autofill.phic_birthdate ||
          prev.birthdate,
        contact_no: autofill.contact_no || autofill.mobile_number || prev.contact_no,
        email: autofill.email || prev.email,
        sex: autofill.sex || prev.sex,
        
        // Address fields
        country: autofill.country || prev.country,
        province: autofill.province || prev.province,
        city: autofill.city || prev.city,
        barangay: autofill.barangay || prev.barangay,
        street: autofill.street || prev.street,
        zip_code: autofill.zip_code || prev.zip_code,
        
        // Civil status and other demographics
        civil_status: autofill.civil_status || prev.civil_status,
        occupation: autofill.occupation || prev.occupation,
        nationality: autofill.nationality || prev.nationality,
        religion: autofill.religion || prev.religion,
        
        // Emergency contact
        emergency_contact: autofill.emergency_contact || prev.emergency_contact,
        emergency_contact_no: autofill.emergency_contact_no || prev.emergency_contact_no,
        relation_w_contact: autofill.relation_w_contact || prev.relation_w_contact,
        
        // Senior/PWD IDs
        senior_id: autofill.senior_id || prev.senior_id,
        pwd_id: autofill.pwd_id || prev.pwd_id,
        is_pwd: autofill.is_pwd || prev.is_pwd,
        
        // PhilHealth fields - only autofill phic_pin for members
        phic_pin: autofill.phic_pin || state?.phic_pin || lsPhicPin || prev.phic_pin,
        phic_membership_type: autofill.phic_membership_type || state?.phic_membership_type || lsMembership || prev.phic_membership_type,
        phic_enlistment_date: autofill.phic_enlistment_date || prev.phic_enlistment_date,
        phic_enlistment_status: autofill.phic_enlistment_status || prev.phic_enlistment_status,
        phic_package_type: autofill.phic_package_type || prev.phic_package_type,
        phic_atc: autofill.phic_atc || state?.atc || prev.phic_atc,
        
        // PhilHealth member/dependent details
        phic_dependent_pin: autofill.phic_dependent_pin || lsPhicDependentPin || prev.phic_dependent_pin,
        phic_last_name: autofill.phic_last_name || autofill.last_name || prev.phic_last_name,
        phic_first_name: autofill.phic_first_name || autofill.first_name || prev.phic_first_name,
        phic_middle_name: autofill.phic_middle_name || autofill.middle_name || prev.phic_middle_name,
        phic_extension_name: autofill.phic_extension_name || autofill.suffix || prev.phic_extension_name,
        phic_birthdate: autofill.phic_birthdate || autofill.birthdate || prev.phic_birthdate,
        phic_contact_no: autofill.phic_contact_no || autofill.contact_no || prev.phic_contact_no,
      }));
    } else if (state?.phic_pin || state?.phic_membership_type || lsPhicPin || lsPhicDependentPin || lsMembership) {
      setAddPatient((prev) => ({
        ...prev,
        phic_pin: state?.phic_pin || lsPhicPin || prev.phic_pin,
        phic_dependent_pin: lsPhicDependentPin || prev.phic_dependent_pin,
        phic_membership_type: state?.phic_membership_type || lsMembership || prev.phic_membership_type,
      }));
    }
  }, [location.state]);

  //handle for storing the image
  const handleSaveImage = (data) => {
    setFileList(data);
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddChange = (e, type) => {
    if (type === "first" || type === "last") {
      const fieldName = type === "first" ? "first_name" : "last_name";
      if (
        isPhilhealthFieldLocked(
          fieldName,
          philhealthAutofillLocks,
          addPatient.phic_membership_type
        )
      ) {
        return;
      }
      // Handling changes from TypeAhead onInputChange
      setAddPatient((prevState) => ({
        ...prevState,
        [fieldName]: e?.toUpperCase(),
      }));
    } else {
      // Handling changes from regular input fields
      const { name, value } = e.target;
      if (
        isPhilhealthFieldLocked(
          name,
          philhealthAutofillLocks,
          addPatient.phic_membership_type
        )
      ) {
        return;
      }
      if (
        name === "email" ||
        name === "phic_membership_type" ||
        name === "phic_enlistment_status" ||
        name === "phic_package_type"
      ) {
        setAddPatient((prevState) => ({
          ...prevState,
          [name]: value, //dili need ipa uppercase ang email
        }));
      } else {
        setAddPatient((prevState) => ({
          ...prevState,
          [name]: value?.toUpperCase(),
        }));
      }
    }
  };

  const handleAddPhoneChange = (e, name) => {
    if (
      isPhilhealthFieldLocked(
        name,
        philhealthAutofillLocks,
        addPatient.phic_membership_type
      )
    ) {
      return;
    }
    if (
      name === "contact_no" &&
      addPatient?.ph_check === true &&
      addPatient?.phic_membership_type === "member" //ma update ang contact number sa philhealth kung e edit ang mobile no. patient details
    ) {
      setAddPatient((prevState) => ({
        ...prevState,
        contact_no: e,
        phic_contact_no: e,
      }));
    } else {
      setAddPatient((prevState) => ({
        ...prevState,
        [name]: e,
      }));
    }
  };

  const handleValueChange = (name, value) => {
    if (addPatient.phic_membership_type === "member") {
      addPatient[name] = value;
      return addPatient[name] || value;
    }
  };

  // Submit button validation checks
  const memberValidationCheck =
    !addPatient.phic_membership_type ||
    !addPatient.phic_pin ||
    !addPatient.phic_first_name ||
    !addPatient.phic_last_name ||
    !addPatient.phic_birthdate ||
    !addPatient.phic_enlistment_date ||
    !addPatient.phic_enlistment_status ||
    !addPatient.phic_package_type ||
    !addPatient.phic_atc;

  const dependentValidationCheck =
    !addPatient.phic_membership_type ||
    !addPatient.phic_pin ||
    !addPatient.phic_dependent_pin ||
    !addPatient.phic_first_name ||
    !addPatient.phic_last_name ||
    !addPatient.phic_birthdate ||
    !addPatient.phic_enlistment_date ||
    !addPatient.phic_enlistment_status ||
    !addPatient.phic_package_type ||
    !addPatient.phic_atc;

  // Add this check for minor patients
  const isMinor = getAge(addPatient.birthdate) < 18;
  const isPWD =
    addPatient?.is_pwd === "1" ||
    addPatient?.is_pwd === 1 ||
    addPatient?.is_pwd === true;
  const needsSeniorPwdEmergencyContact =
    getAge(addPatient.birthdate) >= 60 || isPWD;
  const emergencyContactRequired =
    (isMinor || needsSeniorPwdEmergencyContact) &&
    (!addPatient.emergency_contact?.trim() ||
      !addPatient.relation_w_contact?.trim() ||
      !addPatient.emergency_contact_no?.trim());

  const handleAllergyChange = (e, rowIndex, isSelectField) => {
    const { name, value } = e.target;

    if (isSelectField) {
      setAllergyData((prev) => ({
        ...prev,
        category_name: { ...e.target, name: "category_name" },
      }));
    } else {
      if (rowIndex !== "") {
        setAllergyData((prev) => {
          const _newPrescription = { ...prev };
          _newPrescription.allergyDetails[rowIndex][name] = value;
          return _newPrescription;
        });
      } else {
        setAllergyData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  const navigatePatientProfile = (name) => {
    if (name) {
      navigate("/patients/profile/" + name, {
        state: {
          fromRegisterPatient: true,
        },
      });
    }
    // else {
    //   toast.error("Error Patient Name!!");
    // }
  };

  // function for adding button in the table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center">
          <Col xs={12}>
            <BtnSave
              label={"Select"}
              size={"sm"}
              onClick={(e) => {
                setAddPatient({
                  ...row.row,
                  sex: row?.row?.gender?.toLowerCase(),
                  phone_no: row?.row?.contact_no,
                  status: "",
                  occupation: "",
                  em_person: "",
                  em_phone_no: "",
                  referred_by: "",
                });
                setSelectCustomer(true);
              }}
            />
          </Col>
        </Row>
      </>
    );
  }

  //function for searching customer record
  async function handleSearch() {
    setLoading(true);
    setShowLoader(true);
    setSelectCustomer(false);
    setCustomerData([]);
    if (!isClicked) {
      const response = await searchCustomer(searchData);
      if (response?.status !== 200) {
        toast.error(response?.response?.data?.messages?.error);
      } else {
        setCustomerData(response?.data?.customers);
      }
    }
    setLoading(false);
    setShowLoader(false);
  }

  //function for creating patient
  async function handleSubmit() {
    setLoading(true);
    if (validatePatientProfile(addPatient, setError) && !isClicked) {
      // Step 1: Call CSR API first
      const csrResponse = await createPatientCSR(addPatient, fileList);
      
      // Check if CSR creation was successful
      if (csrResponse && csrResponse.status !== 200) {
        toast.error(csrResponse.response?.data?.messages?.error_messages?.[0] || "Failed to create patient in CSR");
        setPrompt(false);
        setLoading(false);
        return;
      }
      
      // Get patient_master_id from CSR response
      const masterPatientId = csrResponse?.data?.patient_master_id;
      console.log("CSR patient created with patient_master_id:", masterPatientId);
      
      // Step 2: Call EMR API with master_patient_id
      const emrResponse = await createPatient(addPatient, fileList, masterPatientId);
      
      // Check EMR response
      if (emrResponse && emrResponse.status !== 200) {
        toast.error(emrResponse.response.data.messages.error_messages[0]);
        setPrompt(false);
      } else {
        setIsClicked(true);
        toast.success("Patient Successful Added!");
        // setPatientId(response?.data?.patient_id);
        // setSex(addPatient?.sex);
        // setCurrent(1);
        // navigate("/patient/add-vital-sign/" + response.data.patient_id, {
        //   state: { patient: response.data.sex },
        // });
        navigate("/patients/vitals/" + emrResponse.data.patient_id, {
          state: {
            patient_sex: emrResponse.data.sex,
            is_fpe: emrResponse.data.is_fpe,
            months: getMonths(addPatient?.birthdate),
            fromRegisterPatient: true,
          },
        });
        setPrompt(false);
      }
    }
    setLoading(false);
  }

  const [current, setCurrent] = useState(0);
  const onChange = (value) => {
    setCurrent(value);
  };
  const description = "This is a description.";
  /** API -- FOOD ALLERGY */
  async function handleAddFoodAllergy() {
    setIsClicked(true);
    const response = await createAllergy(allergyData, patientId);
    if (response.data) {
      toast.success(response.data.message);
      setAllergyData({
        allergyDetails: [
          {
            type: "",
            name: "",
          },
        ],
      });
    }

    setIsClicked(false);
  }
  const handleAddRow = () => {
    const newRow = {
      name: "",
      type: "",
    };
    setAllergyData((prev) => ({
      ...prev,
      allergyDetails: [...allergyData.allergyDetails, newRow],
    }));
  };
  const handleDeleteRow = (rowId) => {
    var _prescriptionDetail = allergyData.allergyDetails;
    _prescriptionDetail.splice(rowId, 1);
    setAllergyData((prev) => ({
      ...prev,
      allergyDetails: _prescriptionDetail,
    }));
  };

  return (
    <div className="App">
      <Sidebar />
      <div className="add-customer col p-4 pt-4 overflow-scroll">
        <LabelHeader
          text={
            type === "new-patient" ? "ADD NEW PATIENT" : "ADD DIAGNOSIS PATIENT"
          }
        />
        <div className="pt-2 ml-7">
          {type === "new-patient" && (
            <>
              <AddPatientForm
                type={type}
                addPatient={addPatient}
                userData={userData}
                loading={loading}
                isError={isError}
                isChecked={isChecked}
                handleCheckboxChange={handleCheckboxChange}
                handleAddChange={handleAddChange}
                handleAddPhoneChange={handleAddPhoneChange}
                navigatePatientProfile={navigatePatientProfile}
                handleSaveImage={handleSaveImage}
                setAddPatient={setAddPatient}
                handleValueChange={handleValueChange}
                philhealthAutofillLocks={philhealthAutofillLocks}
              />
            </>
          )}
          {/* {type === "diagnosis-patient" && (
            <>
              <div className="row">
                <div className="col-sm-2">
                  <TextField
                    id="patient_no"
                    name="patient_no"
                    formLabel={`Patient Number`}
                    size={`sm`}
                    onChange={handleSearchChange}
                    disabled={searchData?.last_name || searchData?.birthdate}
                  />
                </div>
                <div className="col-sm-4">
                  <TextField
                    id="last_name"
                    name="last_name"
                    formLabel={`Last Name`}
                    size={`sm`}
                    onChange={handleSearchChange}
                    disabled={searchData?.patient_no}
                  />
                </div>
                <div className="col-sm-4">
                  <DateField
                    id="birthdate"
                    name="birthdate"
                    formLabel={`Birthdate`}
                    size={`sm`}
                    onChange={handleSearchChange}
                    isError={isError.birthdate}
                    errorMessage="Birthdate is required."
                    disabled={searchData?.patient_no}
                  />
                </div>
                <div
                  className="col-sm-2 d-flex flex-row align-items-center"
                  style={{ marginTop: "7px" }}
                >
                  <BtnSave
                    label={"Search Customer"}
                    size={"sm"}
                    onClick={() => handleSearch()}
                    isClicked={loading}
                    disabled={validatePatientSearch(searchData)}
                  />
                </div>
              </div>
              {selectCustomer && (
                <>
                  <div>
                    <AddPatientForm
                      type={type}
                      addPatient={addPatient}
                      userData={userData}
                      loading={loading}
                      isError={isError}
                      // isChecked={isChecked}
                      // handleCheckboxChange={handleCheckboxChange}
                      handleAddChange={handleAddChange}
                      navigatePatientProfile={navigatePatientProfile}
                      handleSaveImage={handleSaveImage}
                    />
                  </div>
                </>
              )}
              {customerData?.length !== 0 && !selectCustomer && (
                <>
                  <div className="row">
                    <div className="col-sm-12 all-table">
                      <AntDTable
                        tableHeaders={[
                          "PATIENT NUMBER",
                          "LAST NAME",
                          "FIRST NAME",
                          "BIRTHDATE",
                        ]}
                        headerSelector={[
                          "patient_no",
                          "last_name",
                          "first_name",
                          "birthdate",
                        ]}
                        tableData={customerData}
                        ActionBtn={(row) => ActionBtn(row)}
                        withAction={true}
                        loading={showLoader}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )} */}
          {type === "new-patient" && (
            <>
              <div className="row justify-content-end mt-5 mb-3">
                <div className="col-2">
                  <BtnSave
                    label={"Submit"}
                    size={"sm"}
                    onClick={() => setPrompt(true)}
                    isClicked={loading}
                    disabled={
                      !addPatient ||
                      !addPatient.last_name?.trim() ||
                      !addPatient.first_name?.trim() ||
                      (!addPatient.middle_name?.trim() &&
                        !addPatient.has_no_middle_name) ||
                      !addPatient.country?.trim() ||
                      !addPatient.barangay?.trim() ||
                      !addPatient.province?.trim() ||
                      !addPatient.city?.trim() ||
                      !addPatient.street?.trim() ||
                      !addPatient.zip_code?.trim() ||
                      !addPatient.birthdate?.trim() ||
                      !addPatient.sex ||
                      !addPatient.civil_status ||
                      !addPatient.contact_no?.trim() ||
                      addPatient.contact_no?.length <= 3 ||
                      emergencyContactRequired ||
                      (addPatient.ph_check &&
                        (addPatient.phic_membership_type === "member"
                          ? memberValidationCheck
                          : dependentValidationCheck))
                    }
                  />
                </div>
              </div>
            </>
          )}
          {/* {type === "diagnosis-patient" && (
            <>
              <div className="row justify-content-end mt-5 mb-3">
                {selectCustomer && (
                  <>
                    <div className="col-2">
                      <BtnSave
                        label={"Submit"}
                        size={"sm"}
                        onClick={() => setPrompt(true)}
                        isClicked={loading}
                        disabled={
                          !addPatient ||
                          addPatient.last_name === "" ||
                          addPatient.first_name === "" ||
                          addPatient.middle_name === "" ||
                          addPatient.birthdate === "" ||
                          addPatient.address === "" ||
                          addPatient.sex === "" ||
                          addPatient.email === "" ||
                          addPatient.phone_no === ""
                        }
                      />
                    </div>
                  </>
                )}
              </div>
            </>
          )} */}
        </div>
      </div>
      <ConfirmModal
        show={prompt}
        onHide={() => setPrompt(false)}
        onConfirm={() => handleAddPatient()}
        loading={loading}
        message={
          <>
            Are you sure this is the right patient name?
            <br />({addPatient.last_name + " " + addPatient.first_name || ""})
          </>
        }
      />
    </div>
  );
}

export default AddPatient;
